import AppContainer from '../components/layout/AppContainer';
import TreeContainer from '../components/layout/TreeContainer';

/**
 * Asset Registry - Central configuration for all generator asset types
 * 
 * This registry makes it easy to:
 * 1. Render the appropriate component for each asset type
 * 2. Configure navigation between different asset types
 * 3. Add new asset types in the future
 */
const assetTypes = [
  {
    id: 'buildings',
    name: 'Classic Building',
    component: AppContainer,
    route: '/buildings',
    isDefault: true,
    iconClass: 'building-icon' // For future icon support
  },
  {
    id: 'trees',
    name: 'Trees',
    component: TreeContainer,
    route: '/trees',
    isDefault: false,
    iconClass: 'tree-icon', // For future icon support
    comingSoon: true
  },
  // Future asset types to be added:
  {
    id: 'skyscrapers',
    name: 'Skyscrapers',
    component: null, // Will need to implement this component
    route: '/skyscrapers',
    isDefault: false,
    iconClass: 'skyscraper-icon',
    comingSoon: true
  },
  {
    id: 'vehicles',
    name: 'Vehicles',
    component: null, // Will need to implement this component
    route: '/vehicles',
    isDefault: false,
    iconClass: 'vehicle-icon',
    comingSoon: true
  }
];

/**
 * Get the default asset type
 */
export const getDefaultAssetType = () => {
  return assetTypes.find(type => type.isDefault) || assetTypes[0];
};

/**
 * Get an asset type by route
 */
export const getAssetTypeByRoute = (route) => {
  // Strip leading slash if present for comparison
  const normalizedRoute = route.startsWith('/') ? route : `/${route}`;
  
  // Find matching asset type
  const assetType = assetTypes.find(type => type.route === normalizedRoute);
  
  // Return default if not found
  return assetType || getDefaultAssetType();
};

/**
 * Get all available asset types (optionally excluding coming soon items)
 */
export const getAvailableAssetTypes = (includingComingSoon = true) => {
  return assetTypes.filter(type => includingComingSoon || !type.comingSoon);
};

export default assetTypes; 